module.exports = __webpack_public_path__ + "static/image/font/pc/bmdohyeon-6@3x.jpg?f00a64dd";